import React from 'react';

import {
	SPACE_SETTINGS_DETAILS_ANALYTICS_SOURCE,
	LazySpaceDetailsPage,
} from '@confluence/space-settings';
import {
	CONTAINER_ADMIN_HOME_ID,
	CONTAINER_HOME_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs.ts';

import SpaceBase from '../../SpaceBase/index.js';

export const SpaceSettingsDetailsRoute = ({ params: { spaceKey } }) => {
	return (
		<SpaceBase>
			<LazySpaceDetailsPage spaceKey={spaceKey} />
		</SpaceBase>
	);
};

SpaceSettingsDetailsRoute.NAVIGATION_PARAMS = ({ params: { spaceKey } }, isNav4Enabled) => ({
	Screen: {
		screenEvent: { name: SPACE_SETTINGS_DETAILS_ANALYTICS_SOURCE },
		pageState: { spaceKey },
	},
	MainLayout: {
		navView: isNav4Enabled ? CONTAINER_ADMIN_HOME_ID : CONTAINER_HOME_ID,
	},
});
